import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { languageNames, supportedLanguages } from '../translations';
import styles from '../styles/Global';

const Languages: React.FC = () => {
  const { t } = useLanguage();

  // Map of language codes to display names
  const languagesToShow = [
    { code: 'es', name: languageNames.es },
    { code: 'fr', name: languageNames.fr },
    { code: 'de', name: languageNames.de },
    { code: 'pt', name: languageNames.pt },
    { code: 'pt-BR', name: languageNames['pt-BR'] },
    { code: 'en', name: languageNames.en },
  ];

  return (
    <div className={`min-h-screen ${styles.section} ${styles.bgWhite}`}>
      <div className={`flex items-center flex-col w-11/12 sm:w-full minmd:w-3/4 text-center`}>
        <div className={`${styles.descDiv} fadeUpMini`}>
          <h1 className={`${styles.blackText} ${styles.h1Text}`}>
            {t.languages.title}
          </h1>
          <p className={`${styles.blackText} ${styles.descriptionText} mb-8`}>
            {t.languages.description}
          </p>
          
          {/* Languages Grid */}
          <div className="grid grid-cols-2 md:grid-cols-3 gap-4 md:gap-6 w-full max-w-2xl mx-auto">
            {languagesToShow.map((lang) => (
              <div
                key={lang.code}
                className="flex items-center justify-center p-4 md:p-6 bg-primary/10 rounded-lg hover:bg-primary/20 transition-colors"
              >
                <span className={`${styles.blackText} text-lg md:text-xl font-medium`}>
                  {lang.name}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Languages;
